import { get, set } from 'lodash/object'
import { ceil } from 'lodash/math'
import logger from '../../lib/utils/log'
import { endOfDay, startOfDay } from '../../lib/plugins/date'
import moment from 'moment-timezone'

import axiosApiClient from '../../api/axiosApiClient'
import _ from 'lodash'

const auditLogMutation = {
	setAuditLogActionList: 'SET_AUDIT_LOG_ACTION_LIST',
	setAuditLog: 'SET_AUDIT_LOG',
	setFilter: 'SET_FILTER'
}

const defaultFilter = {
	userId: null,
	orderId: null,
	deliveryId: null,
	action: null,
	status: null,
	minCreatedAt: startOfDay(),
	maxCreatedAt: endOfDay(),
	page: 1,
	limit: 100,
	sortBy: 'createdAt',
	sortDirection: 'DESC'
}

const defaultOptionList = {
	actionOptions: [],
	statusOptions: [
		{ label: 'SUCCEED', value: 'SUCCEED' },
		{ label: 'FAILED', value: 'FAILED' },
		{ label: 'IN_PROGRESS', value: 'IN_PROGRESS' }
	]
}

const state = {
	data: [],
	total: 0,
	totalPage: 1,
	filter: defaultFilter,
	optionList: defaultOptionList
}

const mutations = {
	[auditLogMutation.setAuditLogActionList]: function (
		state,
		{ actionList = [] }
	) {
		const actionOptions = []
		for (const action of actionList)
			actionOptions.push({ label: action, value: action })

		set(state, 'optionList.actionOptions', actionOptions)
	},
	[auditLogMutation.setAuditLog]: function (
		state,
		{ data = [], total = 0, totalPage = 1 }
	) {
		set(state, 'data', data)
		set(state, 'total', total)
		set(state, 'totalPage', totalPage)
	},
	[auditLogMutation.setFilter]: function (state, filter = {}) {
		set(state, 'filter', { ...state.filter, ...filter })
	}
}

const actions = {
	async getActionList({ commit }) {
		const resp = await getAuditLogActionList()
		const actionList = get(resp, 'actionList', [])
		commit(auditLogMutation.setAuditLogActionList, { actionList })
	},
	async getAuditLogs({ state, commit, dispatch }, filter = {}) {
		const params = { ...state.filter, ...filter }

		if (_.isEmpty(filter.userId))
			delete params.userId
		if (_.isEmpty(filter.orderId))
			delete params.orderId
		if (_.isEmpty(filter.deliveryId))
			delete params.deliveryId

		if (!_.isEmpty(filter.maxCreatedAt))
			params.maxCreatedAt = moment(filter.maxCreatedAt).utcOffset(0).format('YYYY-MM-DD HH:mm')
		if (!_.isEmpty(filter.minCreatedAt))
			params.minCreatedAt = moment(filter.minCreatedAt).utcOffset(0).format('YYYY-MM-DD HH:mm')

		const resp = await getAuditLogList(params)
		const data = get(resp, 'data', [])
		const total = get(resp, 'total', 0)
		const totalPage = total <= 100 ? 1 : ceil(total / state.filter.limit)
		
		await dispatch('updateFilter', params)
		commit(auditLogMutation.setAuditLog, { data, total, totalPage })
	},
	updateFilter({ commit }, filter) {
		commit(auditLogMutation.setFilter, filter)
	},
	resetFilter({ commit }) {
		commit(auditLogMutation.setFilter, defaultFilter)
	}
}

const getters = {}

const namespaced = true

async function getAuditLogActionList() {
	try {
		return get(await axiosApiClient('/v1/audit-logs/actions'), 'data', {})
	} catch (e) {
		logger.error(
			'[Backoffice][AuditLogs] Failed to get audit log actionlist',
			e,
			e.stack
		)
		return {}
	}
}

async function getAuditLogList(params = {}) {
	try {
		return get(await axiosApiClient('/audit-logs', { params }), 'data', {})
	} catch (e) {
		logger.error(
			'[Backoffice][AuditLogs] Failed to get audit log list',
			e,
			e.stack
		)
		return {}
	}
}

export default {
	state,
	mutations,
	actions,
	getters,
	namespaced
}
